/**
 * Sets up native sharing when available
 * @module embed/sharing_native
 */

import { delegate } from '@/lib/events';

const SELECTOR = '.js-native-sharing';

export function setupNativeSharing() {
  if (navigator.share) {
    document.documentElement.classList.add('bcs-withWebShare');
    document.addEventListener(
      'click',
      delegate(SELECTOR, (event, target) => {
        event.preventDefault();
        navigator.share({
          url: target.href
        });
      })
    );
  }
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/sharing_native.js